import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { on } from "@ember/modifier";
import { fn } from "@ember/helper";

export default class KeyValueBuilder extends Component {
  @tracked parsedData = [];

  constructor() {
    super(...arguments);
    this.initData();
  }

  initData() {
    try {
      let data = JSON.parse(this.args.value || "{}");
      if (typeof data !== 'object' || Array.isArray(data) || data === null) {
        data = {};
      }
      this.parsedData = Object.keys(data).map(k => ({ key: k, value: data[k] }));
    } catch (e) {
      this.parsedData = [];
    }
  }

  get jsonString() {
    let obj = {};
    this.parsedData.forEach(item => {
      if (item.key.trim()) {
        obj[item.key.trim()] = isNaN(Number(item.value)) ? item.value : Number(item.value);
      }
    });
    return JSON.stringify(obj, null, 2);
  }

  @action
  addField() {
    this.parsedData = [...this.parsedData, { key: "", value: "" }];
    this.args.onChange(this.jsonString);
  }

  @action
  removeField(index) {
    this.parsedData = this.parsedData.filter((_, i) => i !== index);
    this.args.onChange(this.jsonString);
  }

  @action
  updateKey(index, event) {
    let newData = [...this.parsedData];
    newData[index] = { ...newData[index], key: event.target.value };
    this.parsedData = newData;
    this.args.onChange(this.jsonString);
  }

  @action
  updateValue(index, event) {
    let newData = [...this.parsedData];
    newData[index] = { ...newData[index], value: event.target.value };
    this.parsedData = newData;
    this.args.onChange(this.jsonString);
  }

  <template>
    <div class="pd-key-value-builder">
      {{#each this.parsedData as |item index|}}
        <div class="pd-kv-row">
          <input 
            type="text" 
            placeholder={{if @keyPlaceholder @keyPlaceholder "Key"}} 
            value={{item.key}} 
            {{on "input" (fn this.updateKey index)}} 
            class="pd-kv-input"
          />
          <input 
            type="text" 
            placeholder={{if @valPlaceholder @valPlaceholder "Value"}} 
            value={{item.value}} 
            {{on "input" (fn this.updateValue index)}} 
            class="pd-kv-input"
          />
          <button type="button" class="btn btn-danger btn-small" {{on "click" (fn this.removeField index)}}>✕</button>
        </div>
      {{/each}}
      <button type="button" class="btn btn-default btn-small" {{on "click" this.addField}}>
        + Add Field
      </button>
    </div>
  </template>
}
